import React from 'react'

import {
  Box,
  makeStyles,
  Typography,
  Grid,
  Tooltip,
  withStyles,
} from '@material-ui/core'
import styles from './styles'
import helpers from 'helpers'

import checkoutTheme from 'theme/checkoutTheme'
import { PaymentMethodImages } from 'componentsCheckout'

const useStyles = makeStyles(styles)

const ProductDetails = ({ order }) => {
  const classes = useStyles()

  const truncateText = (text, lenghtText) => {
    let result = null

    if (text.length > lenghtText) {
      result = text.substring(0, lenghtText) + '...'
    }
    return result ? result : text
  }

  const LightTooltip = withStyles((checkoutTheme) => ({
    tooltip: {
      backgroundColor: checkoutTheme.palette.white,
      fontSize: 14,
    },
  }))(Tooltip)

  return (
    <Grid container spacing={2}>
      <Grid item lg={12} sm={12} xs={12}>
        <Typography variant="body1" color="textPrimary">
          Você está comprando
        </Typography>
      </Grid>
      <Grid item lg={12} sm={12} xs={12}>
        {order?.products.map((product, index) => (
          <Grid container spacing={2} key={index}>
            {product?.name !== 'Desconto' && (
              <Grid item lg={12} sm={12} xs={12}>
                <Grid item lg={12} sm={12} xs={12}>
                  <Box display="flex" flexDirection="row" alignItems="start">
                    <LightTooltip
                      title={
                        <Typography variant="body2" color="textPrimary">
                          {product?.name}
                        </Typography>
                      }
                      enterTouchDelay={0}
                    >
                      <Typography
                        variant="body1"
                        style={{ maxWidth: '90%' }}
                        className={classes.blueText}
                      >
                        {product?.name}
                      </Typography>
                    </LightTooltip>
                  </Box>
                  <Typography
                    variant="body2"
                    style={{ color: '#598CB9', fontSize: '10px' }}
                    className={classes.blueDescriptionSecondary}
                  >
                    Quant: ({product?.quantity})
                  </Typography>
                </Grid>
                <Grid item lg={12} sm={12} xs={12}>
                  <LightTooltip
                    title={
                      <Typography variant="body2" color="textPrimary">
                        {product?.description}
                      </Typography>
                    }
                    enterTouchDelay={0}
                    componentsProps={{
                      tooltip: {
                        sx: {
                          bgcolor: 'red',
                          '& .MuiTooltip-arrow': {
                            color: 'common.black',
                          },
                        },
                      },
                    }}
                  >
                    <Typography
                      className={classes.blueDescription}
                      variant="body1"
                      color="textPrimary"
                    >
                      {truncateText(product?.description, 40)}
                    </Typography>
                  </LightTooltip>
                </Grid>
                <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Typography variant="body1" className={classes.price}>
                    R${' '}
                    {helpers.formatters.floatToMoney(
                      parseFloat(product?.price) * product?.quantity,
                    )}
                  </Typography>
                </Grid>
              </Grid>
            )}
          </Grid>
        ))}
      </Grid>
      <Grid item lg={12} sm={12} xs={12}>
        <Box mt={checkoutTheme.spacing(4)}>
          <Typography variant="body1" className={classes.blueText}>
            Total
          </Typography>
        </Box>
        <Box display="flex" direction="row" alignItems="center">
          <Typography variant="body2" className={classes.blueTextSecondary}>
            R$
          </Typography>
          <Typography variant="h6" className={classes.blueTextMain}>
            {helpers.formatters.floatToMoney(Number(order?.value))}
          </Typography>
        </Box>
        <PaymentMethodImages />
      </Grid>
    </Grid>
  )
}

export default ProductDetails
